exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-2[data-v-0d0cd77d] {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n}\n", ""]);

// exports
